// Dividends Getters

export const getDividendsList = state => {
  return state.dividendsList
}

export const getDividendInfo = state => {
  return state.dividendInfo
}

export const getIncomeAfterTax = state => {
  return state.incomeAfterTax
}
